import CopyWrapper from './copyWrapper';

export default CopyWrapper;
